module.exports = __webpack_public_path__ + "static/ILUMINACION-9239d659806400b41c05c519d488c1e1.webp";